import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';

export const cn = (...inputs) => twMerge(clsx(inputs));

export const formatCurrency = (amt) => 
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amt);

export const fmtDate = (date, pattern = 'dd MMM yyyy') => 
  date ? format(new Date(date), pattern) : '';